const TOLL_FREE = '8333090500';
const TOLL_FREE_FORMATTED = '833-309-0500 (TTY 711)';

export default {
  DEFAULT: TOLL_FREE,
  DEFAULT_FORMATTED: TOLL_FREE_FORMATTED,
  TOLL_FREE,
  TOLL_FREE_FORMATTED,
};
